import { FC, useContext } from "react";
import { Link } from "react-router-dom";

import DownloadIcon from "@mui/icons-material/Download";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Box, Button } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { Translate } from "@/components/Application/Translate";

import { ArchiveProject } from "@/model/Archive/ArchivedProjectsRequest";
import { UserContext } from "@/model/User/UserContext";

import { insertDomain } from "@/service/ApplicationQueries";

dayjs.extend(utc);

interface IArchiveProcedureLink {
	item: ArchiveProject;
}

export const ArchiveProcedureLink: FC<IArchiveProcedureLink> = (props) => {
	const user = useContext(UserContext);

	if (props.item.FileCreated) {
		const path = insertDomain(props.item.Link, {
			insertIntoHtmlElement: false,
		});

		return (
			<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
				<Button
					variant="contained"
					color="info"
					href={path}
					download
					sx={{ textTransform: "none" }}
					startIcon={<DownloadIcon />}
					size="small"
				>
					<Translate String="Archive.File.Download">Download</Translate>
				</Button>
			</Box>
		);
	}

	const path = insertDomain(
		`/archivechecklists?checklistParentId=${props.item.Id}&companyId=${user?.CompanyId}`,
		{
			insertIntoHtmlElement: true,
		},
	);

	return (
		<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
			<Button
				variant="outlined"
				color="info"
				component={Link}
				to={path}
				target="_blank"
				sx={{ textTransform: "none" }}
				startIcon={<RemoveRedEyeIcon />}
				size="small"
			>
				<Translate String="Archive.File.Preview">Preview</Translate>
			</Button>
		</Box>
	);
};
